import React, { useState } from "react";
import {
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Grid,
  Box,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { useOutletContext } from "react-router-dom";  // Import Outlet context

const DeviceMap: React.FC = () => {
  const { isLoaded } = useOutletContext<{ isLoaded: boolean }>();  // Use shared loader
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");
  const [networkPartner, setNetworkPartner] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [polygon, setPolygon] = useState(false);
  const [device, setDevice] = useState(false);
  const [lead, setLead] = useState(false);
  const [location, setLocation] = useState<{ lat: number; lng: number } | null>(null);

  const cities = ["Mumbai", "Delhi", "Bangalore", "Kolkata", "Chennai", "Hyderabad", "Ahmedabad", "Pune", "Jaipur", "Surat", "Lucknow"];

  const handleSearch = () => {
    console.log({
      city,
      pincode,
      networkPartner,
      fromDate,
      toDate,
      polygon,
      device,
      lead,
    });

    if (pincode) {
      fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${pincode}&key=${googleMapsApiKey}`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.results.length > 0) {
            const { lat, lng } = data.results[0].geometry.location;
            setLocation({ lat, lng });
          } else {
            alert("Invalid pin code or no data found.");
          }
        })
        .catch((error) => console.error("Error fetching location:", error));
    }
  };

  const containerStyle = {
    width: "100%",
    height: "100vh",
  };

  const center = location || { lat: 28.6139, lng: 77.209 };

  return (
    <Box sx={{ position: "relative", width: "100%", height: "100vh" }}>
      <Box
        sx={{
          position: "absolute",
          top: 20,
          left: 20,
          zIndex: 1000,
          bgcolor: "rgba(255, 255, 255, 0.9)",
          p: 3,
          borderRadius: 1,
          boxShadow: 2,
          width: "400px",
        }}
      >
        <Typography variant="h5" gutterBottom>Find Your Locality</Typography>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Select City</InputLabel>
              <Select
                label="Select City"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              >
                {cities.map((cityName) => (
                  <MenuItem key={cityName} value={cityName}>
                    {cityName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Enter Pincode"
              variant="outlined"
              fullWidth
              value={pincode}
              onChange={(e) => setPincode(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Enter Network Partner"
              variant="outlined"
              fullWidth
              value={networkPartner}
              onChange={(e) => setNetworkPartner(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="From Date"
              variant="outlined"
              fullWidth
              type="date"
              InputLabelProps={{ shrink: true }}
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="To Date"
              variant="outlined"
              fullWidth
              type="date"
              InputLabelProps={{ shrink: true }}
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Grid>

          <Grid container spacing={0} justifyContent="space-between" alignItems="center">
            <Grid item>
              <Button variant="contained" color="primary" onClick={handleSearch}>
                Search
              </Button>
            </Grid>

            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={polygon}
                    onChange={() => setPolygon(!polygon)}
                    color="primary"
                  />
                }
                label="Polygon"
              />
            </Grid>

            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={device}
                    onChange={() => setDevice(!device)}
                    color="primary"
                  />
                }
                label="Device"
              />
            </Grid>

            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={lead}
                    onChange={() => setLead(!lead)}
                    color="primary"
                  />
                }
                label="Lead"
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>

      {isLoaded ? (
        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={13}>
          {location && <Marker position={location} />}
        </GoogleMap>
      ) : (
        <Typography>Loading map...</Typography>
      )}
    </Box>
  );
};

export default DeviceMap;
